export const name = 'Markus Tacker'
export const tagLine = 'Software Crafter'
